class WirisDialogHider {
    constructor() {
        this.observer = new MutationObserver(this.handleMutations.bind(this));
    }

    handleMutations(mutations) {
        mutations.forEach((mutation) => {
            mutation.target.classList.forEach((className) => {
                if (mutation.target.classList.contains('wrs_modal_dialogContainer')) {
                    if (mutation.target.classList.contains('wrs_stack')) {
                        // When wrs_stack is added, the Wiris modal is active, hide the dialog
                        this.hideDialog();
                    }
                    if (mutation.target.classList.contains('wrs_closed')) {
                        // When wrs_closed is added, the Wiris modal is closed, show the dialog again
                        this.showDialog();
                    }
                }
            });
        });
    }

    hideDialog() {
        const dialog = document.querySelector('div[role="dialog"][aria-modal="true"]');
        if (dialog) {
            dialog.style.display = 'none'; // Hide the dialog
        }
    }

    showDialog() {
        const dialog = document.querySelector('div[role="dialog"][aria-modal="true"]');
        if (dialog) {
            dialog.style.display = 'block'; // Show the dialog again
        }
    }

    startObserving() {
        // Start observing the DOM for class attribute changes
        this.observer.observe(document.body, {
            attributes: true, // Watch for attribute changes
            childList: true, // Watch for added/removed nodes
            subtree: true, // Watch all descendants
            attributeFilter: ['class'] // Only track class attribute changes
        });
    }

    stopObserving() {
        // Disconnect the observer when it's no longer needed
        this.observer.disconnect();
    }
}

// Export an instance for global usage
const wirisDialogHider = new WirisDialogHider();
export default wirisDialogHider;
